import TableRows from './TableRows'

export default TableRows
